import { default as module } from './AbstractModule';

const EVENT = {
    SHOW: 'show.LineByLine'
}

export default class extends module {
    constructor(m) {
        super(m);

        this.split = new SplitText(this.el, {
            type: 'lines',
            linesClass: 'c-line-by-line_line'
        })
    }

    init() {
        this.onResizeBind = () => {
            this.split.split({
                type: 'lines'
            })
        }
        window.addEventListener('resize', this.onResizeBind)
    }

    destroy() {
        window.removeEventListener('resize', this.onResizeBind)
    }
}
